import apiService from 'frontcore/data/api-service/api-service'
import {
  AuthorizationAPIClient,
  AuthorizationPayload,
  AuthorizationResponse,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import { AuthorizationError } from 'frontcore/domain/authorization/model/AuthorizationLoginService'

export default class AuthorizationHTTPAPIClient implements AuthorizationAPIClient {

  async login (payload: AuthorizationPayload): Promise<string> {
    try {
      const url = payload.url ?? '/login/'
      delete payload.url
      const response = await apiService
        .buildRequest()
        .post<AuthorizationPayload, AuthorizationResponse, AuthorizationPayload>(url, payload)
      return response.data.token
    } catch (e: unknown) {
      throw new AuthorizationError((e as Error).message)
    }
  }
}
